import { Button, Checkbox, CircularProgress, DialogContent, Tooltip } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import PrintIcon from "@material-ui/icons/Print";
import DialogActions from "@material-ui/core/DialogActions";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import CloseIcon from "@material-ui/icons/Close";
import AccessTimeFilledIcon from "@material-ui/icons/AccessTimeOutlined";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createVocabularyNewWordList,
  getVocabularyContents,
  getVocabularySearchedWord,
  getVocabularyWordList,
  resetAddListParams,
  resetDeleteWordListParams,
  resetSearchParams,
  vocabularyDeleteWordList,
  vocabularyUpdateWordList,
  resetUpdateWordListParams,
} from "../../../redux/actions/vocabularyCenterAction";
import "./vocabularyCenter.scss";
import allActions from "../../../redux/actions";
import { optionConstants, TRANSLATION, LANGUAGE_ENGLISH } from "./optionConstants";
import AddWords from "./AddWords/AddWords";
import { USER, NON_CASE_SENSITIVE } from "../../../redux/constants";
import CreateNewWord from "./CreateNewWord/CreateNewWord";
import ReactTableSkeleton from "./ReactTable";
import translate from "../../../i18n/translate";

const VocabularyCenter = () => {
  const dispatch = useDispatch();
  const reduxState = useSelector((state: any) => state);
  const [isCalled, setIsCalled] = useState<boolean>(false);
  const [showingNow, setShowingNow] = useState<string>("");
  const [searchText, setSearchText] = useState<string>("");
  const [mainTopics, setMainTopics] = useState<any>([]);
  const [expandTopicDetails, setExpandTopicDetails] = useState<string>("");
  const [subTopic, setSubTopic] = useState<any>({});
  const [open, setOpen] = useState<boolean>(false);
  const [optionExpand, setOptionExpand] = useState<boolean>(false);
  const [, updateState] = React.useState<any>();
  const forceUpdate = React.useCallback(() => updateState({}), []);
  const [showSearchContents, setShowSearchContents] = useState<boolean>(false);
  const [showAddWordContents, setShowAddWordContents] = useState<boolean>(false);
  const [tableInfoDetails, setTableInfoDetails] = useState<any>({});
  const [showAddList, setShowAddList] = useState<boolean>(false);
  const [alreadyExistsMessage, setAlreadyExistsMessage] = useState<boolean>(false);
  const [newWordListTitle, setNewWordListTitle] = useState<string>("");
  const [updatedRequestedWordListId, setUpdatedRequestedWordListId] = useState<any>("");
  const [isDeleteWaringToShown, setIsDeleteWaringToShown] = useState<boolean>(false);
  const [isHardLoading, setIsHardLoading] = useState<boolean>(false);
  const [currentScopedDeletedList, setCurrentScopedDeletedList] = useState<any>();
  const [editWordList, setEditWordList] = useState<boolean>(false);

  useEffect(() => {
    const peopleInfoStateValidation = reduxState.peopleInformation ? reduxState.peopleInformation.data : "";
    if (
      peopleInfoStateValidation !== null &&
      reduxState.common &&
      reduxState.common.lgId !== "" &&
      !isCalled &&
      Object.keys(reduxState.vocabularyContents.headerLevelContents).length < 1
    ) {
      setIsCalled(true);
      dispatch(
        getVocabularyContents(
          reduxState.common.lgId,
          peopleInfoStateValidation.getpeopleInformation.token,
          parseInt(peopleInfoStateValidation.getpeopleInformation.accountId, 10)
        )
      );
    }
    if (
      reduxState.vocabularyContents &&
      reduxState.vocabularyContents.headerLevelContents &&
      Object.keys(reduxState.vocabularyContents.headerLevelContents).length > 0
    ) {
      const localizedResponse = reduxState.vocabularyContents.headerLevelContents;
      const framedWordLists: any = [];
      const commonWordLists = localizedResponse.Common;
      const organisationWordLists = localizedResponse.Organization;
      const userWordLists = localizedResponse.User;
      if (commonWordLists && Object.keys(commonWordLists).length > 0) {
        framedWordLists["Industry Word Lists"] = commonWordLists["Industry_Word_Lists"];
        framedWordLists["Topic Word Lists"] = commonWordLists["Topic_Word_Lists"];
      }
      if (organisationWordLists && Object.keys(organisationWordLists).length > 0) {
        framedWordLists["Organisation Word Lists"] = organisationWordLists["Industry_Word_Lists"];
      }
      framedWordLists["My Word Lists"] = userWordLists["userWordlists"];
      const totalHeadTopics = Object.keys(framedWordLists);
      const subTopicsOfHead = totalHeadTopics.length > 0 ? framedWordLists[totalHeadTopics[0]] : "";
      const firstSubTopic = typeof subTopicsOfHead === "object" && subTopicsOfHead.length > 0 ? subTopicsOfHead[0] : "";
      if (firstSubTopic && typeof firstSubTopic === "object") {
        setSubTopic(firstSubTopic);
      }
      setMainTopics(framedWordLists);
    }
    if (
      reduxState.vocabularyContents &&
      reduxState.vocabularyContents.error &&
      Object.keys(reduxState.vocabularyContents.error).length > 0
    ) {
      dispatch(allActions.toasterActions.showToastMessage(true, "error", "message_errorDefault"));
    }
    if (
      reduxState.vocabularyContents &&
      !reduxState.vocabularyContents.isWordListDeleting &&
      reduxState.vocabularyContents.isWordListDeleted
    ) {
      setIsHardLoading(false);
      if (isDeleteWaringToShown) {
        setCurrentScopedDeletedList("");
        setIsDeleteWaringToShown(false);
        dispatch(resetDeleteWordListParams());
      }
      dispatch(
        getVocabularyContents(
          reduxState.common.lgId,
          peopleInfoStateValidation.getpeopleInformation.token,
          parseInt(peopleInfoStateValidation.getpeopleInformation.accountId, 10)
        )
      );
    }
  }, [reduxState]);

  useEffect(() => {
    if (Object.keys(subTopic).length > 0) {
      dispatch(
        getVocabularyWordList(
          reduxState.common.lgId,
          reduxState.peopleInformation.data.getpeopleInformation.token,
          subTopic.listId,
          TRANSLATION,
          LANGUAGE_ENGLISH
        )
      );
      let relatedHeadTopic = "";
      Object.keys(mainTopics).forEach((mainTopic: string) => {
        const isAvailableInThisHead = mainTopics[mainTopic]
          ? mainTopics[mainTopic].findIndex((subTopicObj: any) => subTopicObj.listId === subTopic.listId)
          : -1;
        if (isAvailableInThisHead !== -1) {
          relatedHeadTopic = mainTopic;
        }
      });
      if (relatedHeadTopic !== "") {
        setExpandTopicDetails(relatedHeadTopic);
      }
      setShowingNow(subTopic.wordlist);
    }
  }, [subTopic]);

  useEffect(() => {
    if (tableInfoDetails && Object.keys(tableInfoDetails).length > 0) {
      setOpen(true);
      setShowSearchContents(true);
    }
  }, [tableInfoDetails]);

  const handleTextChange = (e: any) => {
    /* const searchSorted = tableBodyContents.slice().filter((tableRow: any) => tableRow.Word.includes(e.target.value));
    if (e.target.value.length === 0) {
      setSearchSortedData([]);
    }
    setSearchSortedData(searchSorted); */
    setSearchText(e.target.value);
  };

  const handleSearch = (e: any) => {
    if (e && e.key && e.key.toUpperCase() === "ENTER" && searchText.length > 0) {
      dispatch(
        getVocabularySearchedWord(
          reduxState.common.lgId,
          reduxState.peopleInformation.data.getpeopleInformation.token,
          searchText,
          USER,
          NON_CASE_SENSITIVE
        )
      );
      setOpen(true);
      setShowSearchContents(true);
    }
  };

  const handleClose = (event: React.SyntheticEvent<unknown>, reason?: string) => {
    if (reason !== "backdropClick") {
      if (isDeleteWaringToShown) {
        setIsDeleteWaringToShown(false);
      }
      if (showAddList) {
        if (editWordList) {
          dispatch(resetUpdateWordListParams());
          setEditWordList(false);
          setUpdatedRequestedWordListId("");
          dispatch(
            getVocabularyContents(
              reduxState.common.lgId,
              reduxState.peopleInformation.data.getpeopleInformation.token,
              parseInt(reduxState.peopleInformation.data.getpeopleInformation.accountId, 10)
            )
          );
        }
        dispatch(resetAddListParams());
        setShowAddList(false);
        setAlreadyExistsMessage(false);
        setNewWordListTitle("");
        setOptionExpand(false);
        setOpen(false);
      } else if (showSearchContents || showAddWordContents) {
        dispatch(resetSearchParams());
        setShowAddWordContents(false);
        setSearchText("");
        setTableInfoDetails({});
        setShowSearchContents(false);
        setOptionExpand(false);
        setOpen(false);
      } else {
        setOptionExpand(false);
        setOpen(false);
      }
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const frameDefaultCheckBoxOptions = () => {
    return optionConstants.map((optionConstant: any) => {
      return {
        checked: true,
        name: optionConstant,
      };
    });
  };

  const isFilterChecked = (optionKey: any) => {
    const isChecked = selectedFilters.filter((filterKey: any) => filterKey.name === optionKey);
    if (isChecked.length > 0) {
      return isChecked[0].checked;
    } else {
      return false;
    }
  };

  const [selectedFilters, setSelectedFilters] = useState<any>(frameDefaultCheckBoxOptions());

  const handleCheckedOptions = (e: any) => {
    const isAvailable = selectedFilters.findIndex((filterOption: any) => filterOption.name === e.target.name);
    if (isAvailable !== -1) {
      selectedFilters[isAvailable].checked = e.target.checked;
    }
    setSelectedFilters(selectedFilters);
    forceUpdate();
  };

  // Used to validate the checked count
  const checkUnCheckedCount = () => {
    const unCheckedSegments = selectedFilters.filter((filterOption: any) => !filterOption.checked);
    if (unCheckedSegments.length === optionConstants.length) {
      return true;
    } else {
      return false;
    }
  };

  const getSearchedWordDetails = () => {
    if (tableInfoDetails && Object.keys(tableInfoDetails).length > 0) {
      return tableInfoDetails;
    }
  };

  const validateNewWordListTitle = () => {
    const userWordList = mainTopics["My Word Lists"];
    const isExists = userWordList
      ? userWordList.findIndex((listDetails: any) => listDetails.wordlist === newWordListTitle)
      : -1;
    if (isExists !== -1) {
      setAlreadyExistsMessage(true);
    } else {
      if (editWordList) {
        dispatch(
          vocabularyUpdateWordList(
            reduxState.peopleInformation.data.getpeopleInformation.token,
            updatedRequestedWordListId,
            newWordListTitle,
            USER
          )
        );
      } else {
        dispatch(
          createVocabularyNewWordList(
            reduxState.peopleInformation.data.getpeopleInformation.token,
            newWordListTitle,
            USER
          )
        );
      }
    }
  };

  const deleteWordList = (wordListId: any) => {
    setCurrentScopedDeletedList(wordListId);
    setIsDeleteWaringToShown(true);
    setOpen(true);
  };

  const getSelectedFilters = () => {
    const selectedOptions = selectedFilters.filter((filterOption: any) => !filterOption.checked);
    return selectedOptions;
  };

  return (
    <div className="vocabulary-center-container">
      <div className="header-title-details">
        <h3 className="header-label">{translate("vocab_center_product_headline")}</h3>
      </div>
      <div className="vocabulary-content-details">
        {(reduxState.vocabularyContents.isLoading ||
          reduxState.vocabularyContents.isSubTopicLoading ||
          isHardLoading) && (
          <div className="loader-wrapper">
            <CircularProgress color="primary" className="circularLoader" size={100} />
          </div>
        )}
        <div className="table-outer-layer">
          <div className="table-header-layer">
            <div className="table-header-30">
              <Paper className="filter-container">
                <InputBase
                  className="text-bar-in-search"
                  placeholder="Search and add word"
                  inputProps={{ "aria-label": "Search and add word" }}
                  value={searchText}
                  onChange={handleTextChange}
                  onKeyPress={handleSearch}
                />
                <IconButton
                  type="button"
                  className="search-icon-button"
                  aria-label="search"
                  onClick={() => handleSearch({ key: "ENTER" })}
                  disabled={searchText.length === 0}
                >
                  <SearchIcon className="search-icon" />
                </IconButton>
              </Paper>
            </div>
            <div className="table-header-70">
              <p className="showing-now-label">{showingNow}</p>
              <div className="button-container">
                <Button
                  onClick={() => {
                    setOptionExpand(true);
                    handleClickOpen();
                  }}
                  className="option-filter-button"
                  disableRipple={true}
                >
                  {translate("vocab_center_options_text")}
                  {optionExpand ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </Button>
                <Tooltip title={translate("vocab_center_print_text")}>
                  <PrintIcon className="print-icon" onClick={() => {
                    window.print();
                  }}/>
                </Tooltip>
              </div>
            </div>
          </div>
          <div className="table-content-layer">
            <div className="table-content-list-layer">
              {Object.keys(mainTopics).map((key: any) => (
                <>
                  <p className="table-content-list-main-topic">
                    <div className="main-topic-30">
                      <span
                        className="main-topic-label"
                        onClick={() => setExpandTopicDetails(expandTopicDetails === key ? "" : key)}
                      >
                        {key}
                      </span>
                      {key === "My Word Lists" && (
                        <span className="main-topic-action">
                          <Tooltip title={translate("vocab_center_add_wordlist")}>
                            <AddCircleIcon
                              className="add-icon"
                              onClick={() => {
                                setShowAddList(true);
                                setOpen(true);
                              }}
                              aria-label="add new list"
                            />
                          </Tooltip>
                        </span>
                      )}
                    </div>
                    <div
                      className="expand-collapse-action"
                      onClick={() => setExpandTopicDetails(expandTopicDetails === key ? "" : key)}
                    >
                      {expandTopicDetails === key ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </div>
                  </p>
                  {expandTopicDetails === key && (
                    <div className="sub-topic-details">
                      {mainTopics[key] &&
                        mainTopics[key].map((subTopic: any) => (
                          <React.Fragment key={subTopic.listId}>
                            <p
                              className={`table-content-list-sub-topic ${
                                showingNow === subTopic.wordlist ? "showing-now" : ""
                              }`}
                              id={subTopic.listId}
                            >
                              <span
                                className="list-label"
                                onClick={() => {
                                  setShowingNow(subTopic.wordlist);
                                  dispatch(
                                    getVocabularyWordList(
                                      reduxState.common.lgId,
                                      reduxState.peopleInformation.data.getpeopleInformation.token,
                                      subTopic.listId,
                                      TRANSLATION,
                                      LANGUAGE_ENGLISH
                                    )
                                  );
                                }}
                              >
                                {subTopic.wordlist} ({subTopic.wordCount})
                              </span>
                              {showingNow === subTopic.wordlist && key === "My Word Lists" && (
                                <span className="list-label-actions">
                                  {" "}
                                  <Tooltip title={translate("vocab_center_edit_wordlist")}>
                                    <CreateIcon
                                      className="edit-icon"
                                      aria-label="edit new list"
                                      onClick={() => {
                                        setUpdatedRequestedWordListId(subTopic.listId);
                                        setNewWordListTitle(subTopic.wordlist);
                                        setEditWordList(true);
                                        setShowAddList(true);
                                        setOpen(true);
                                      }}
                                    />
                                  </Tooltip>
                                  <Tooltip title={translate("vocab_center_delete_wordlist")}>
                                    <DeleteIcon
                                      className="delete-icon"
                                      aria-label="delete new list"
                                      onClick={() => deleteWordList(subTopic.listId)}
                                    />
                                  </Tooltip>
                                </span>
                              )}
                            </p>
                          </React.Fragment>
                        ))}
                    </div>
                  )}
                </>
              ))}
            </div>
            <div className="table-content-details">
              <div className="table-content-table-layer" id="table-body-contents">
                <ReactTableSkeleton setInfoDetails={setTableInfoDetails} selectedFilters={getSelectedFilters()} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dialog
        disableEscapeKeyDown
        open={open}
        onClose={handleClose}
        className={`vocabulary-center-pop-up ${showSearchContents || showAddWordContents ? "search-component" : ""}`}
      >
        <DialogContent className="vocabulary-center-pop-up-contents">
          {isDeleteWaringToShown && (
            <div className="delete-warning-container">
              <div className="title-container">
                <p className="new-word-label">{translate("vocab_center_delete_wordlist")}</p>
                <CloseIcon className="close-icon" onClick={handleClose} />
              </div>
              <p className="delete-warning-message">{translate("vocab_center_delete_wordlist_warning_message")}</p>
              <Button
                variant="contained"
                className="delete-button"
                onClick={() => {
                  setIsHardLoading(true);
                  dispatch(
                    vocabularyDeleteWordList(
                      reduxState.peopleInformation.data.getpeopleInformation.token,
                      currentScopedDeletedList
                    )
                  );
                  setOpen(false);
                }}
              >
                {translate("vocab_center_yes_text")}
              </Button>
            </div>
          )}
          {showAddWordContents ? (
            <CreateNewWord handleClose={handleClose} />
          ) : showAddList ? (
            <div className="add-word-list-box">
              <div className="title-container">
                <p className="new-word-label">
                  {editWordList ? translate("vocab_center_edit_wordlist") : translate("vocab_center_new_wordlist")}
                </p>
                <CloseIcon className="close-icon" onClick={handleClose} />
              </div>
              {reduxState.vocabularyContents.isWordListCreated || reduxState.vocabularyContents.isWordListUpdated ? (
                <div className="add-word-list-success-message-box">
                  <p className="success-message-para">
                    {editWordList
                      ? translate("vocab_center_updated_wordlist_success_message")
                      : translate("vocab_center_created_wordlist_success_message")}
                  </p>
                </div>
              ) : (
                <>
                  <div className="add-wordlist-core-container">
                    <p className="add-wordlist-label">
                      {editWordList
                        ? translate("vocab_center_update_wordlist")
                        : translate("vocab_center_new_wordlist")}
                      :
                    </p>
                    <input
                      type="text"
                      className="add-wordlist-input"
                      value={newWordListTitle}
                      maxLength={40}
                      onChange={(e) => {
                        setAlreadyExistsMessage(false);
                        setNewWordListTitle(e.target.value);
                      }}
                    />
                  </div>
                  {alreadyExistsMessage && (
                    <div className="already-exists-container">
                      <AccessTimeFilledIcon className="history-icon" />
                      <p className="already-exists-label">
                        {translate("vocab_center_word_exists_in_wordlist_warning_message")}.
                      </p>
                    </div>
                  )}
                  <Button
                    variant="contained"
                    onClick={validateNewWordListTitle}
                    className="save-button-add-wordlist"
                    disabled={
                      alreadyExistsMessage ||
                      reduxState.vocabularyContents.isWordListCreating ||
                      reduxState.vocabularyContents.isWordListUpdating ||
                      newWordListTitle.length === 0
                    }
                  >
                    {reduxState.vocabularyContents.isWordListUpdating ||
                    reduxState.vocabularyContents.isWordListCreating ? (
                      <CircularProgress size="20" />
                    ) : (
                      translate("vocab_center_save_text")
                    )}
                  </Button>
                </>
              )}
            </div>
          ) : showSearchContents ? (
            <AddWords handleClose={handleClose} newWordTitle={searchText} infoDetails={getSearchedWordDetails()} />
          ) : (
            optionExpand &&
            optionConstants.map((option: any) => (
              <div className="option-filter-type">
                <Checkbox
                  checked={isFilterChecked(option)}
                  onChange={handleCheckedOptions}
                  className="option-filter-checkbox"
                  name={option}
                />
                <p className="option-label">{option}</p>
              </div>
            ))
          )}
        </DialogContent>
        <DialogActions className="vocabulary-center-pop-up-actions">
          {showAddList || showSearchContents || showAddWordContents || isDeleteWaringToShown ? (
            <></>
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={handleClose}
              className="vocabulary-center-pop-up-actions-okay"
              disabled={checkUnCheckedCount()}
            >
              {translate("vocab_center_okay_text")}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default VocabularyCenter;
